compiler('[enabled-by-checked]', (element) => {
  const checkBoxName = element.getAttribute('enabled-by-checked');
  const checkBoxes =   document.querySelectorAll(`[name="${checkBoxName}"]`);
  const enableValues = element.getAttribute('enabled-by-checked-values').split(",");

  function toggleEnabled() {
    element.disabled = !Array.from(checkBoxes).some((checkBox) => {
      return checkBox.checked && enableValues.includes(checkBox.value);
    });

    if(element.disabled){
      element.checked = false;
    }
  }

  checkBoxes.forEach((checkBox) => {
    checkBox.addEventListener('change', () => {
      toggleEnabled();
    });
  });

  toggleEnabled();
})
